{
  "DeleteReminder": "Elimina promemoria",
  "EditReminder": "Modifica promemoria",
  "RemindMe15Min": "Ricordami tra 15 minuti",
  "RemindMe5Min": "Ricordami tra 5 minuti",
  "RemindMe60Min": "Ricordami tra 1 ora",
  "RemindMeTomorrow": "Ricordami domani",
  "SetReminder": "Promemoria impostato per {formattedReminderTime}",
  "Snooze": "Posponi"
}
